import { Reveal, Eyebrow } from "@/components/site/Reveal";

const TILES = [
  { img: "/img/vista-8.jpg", title: "Piscina aquecida", text: "Nas duas acomodações, com hidromassagem na Cabana Boutique.", cls: "md:col-span-2 md:row-span-2" },
  { img: "/img/vista-1.jpg", title: "Lareira & adega", text: "Noites frias com vinho na temperatura certa.", cls: "" },
  { img: "/img/boutique-4.jpg", title: "Fogo de chão", text: "Sob o céu da serra.", cls: "" },
  { img: "/img/boutique-6.jpg", title: "Enxoval Trussardi", text: "Cama Queen Size com jogo de cama 400 fios.", cls: "md:col-span-2" },
];

export default function Experience() {
  return (
    <section id="experiencia" data-testid="experience-section" className="grain relative bg-[#163323] py-24 text-[#faf7f2] lg:py-32">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <Eyebrow light>A experiência</Eyebrow>
            <h2 className="mt-6 text-4xl font-bold uppercase leading-[1] tracking-[-0.03em] sm:text-5xl lg:text-6xl">
              Dois refúgios.<br />
              <span className="text-[#e9c9a8]">Um só ritmo:</span> o seu.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="self-end lg:col-span-4 lg:col-start-9">
            <p className="text-base leading-relaxed text-[#d9d4c9] md:text-lg">
              Cada chalé foi pensado para casais que buscam privacidade total: estacionamento privativo, piscina só sua e cada detalhe escolhido a dedo.
            </p>
          </Reveal>
        </div>
        <div className="mt-14 grid auto-rows-[260px] gap-4 md:grid-cols-4 md:auto-rows-[240px]">
          {TILES.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.08} className={`h-full ${t.cls}`}>
              <div data-testid={`experience-tile-${i}`} className="group relative h-full overflow-hidden rounded-sm">
                <img src={t.img} alt={t.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d2016]/90 via-[#0d2016]/20 to-transparent" />
                <div className="absolute bottom-0 p-6">
                  <h3 className="text-xl font-bold uppercase tracking-tight">{t.title}</h3>
                  <p className="mt-1 text-sm text-[#e4dfd5]">{t.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
